import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import apiClient from "./apiClient"; // centralized axios instance

const ENDPOINT = "/training-cards/";

// Async Thunks

export const fetchTrainingCards = createAsyncThunk(
  "trainingCards/fetchTrainingCards",
  async (_, { rejectWithValue }) => {
    try {
      const res = await apiClient.get(ENDPOINT);
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || "Failed to fetch training cards");
    }
  }
);

export const insertTrainingCard = createAsyncThunk(
  "trainingCards/insertTrainingCard",
  async (trainingCard, { rejectWithValue }) => {
    try {
      const res = await apiClient.post(ENDPOINT, trainingCard);
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || "Failed to add training card");
    }
  }
);

export const updateTrainingCard = createAsyncThunk(
  "trainingCards/updateTrainingCard",
  async (trainingCard, { rejectWithValue }) => {
    try {
      const res = await apiClient.put(`${ENDPOINT}${trainingCard.id}/`, trainingCard);
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || "Failed to update training card");
    }
  }
);

export const deleteTrainingCard = createAsyncThunk(
  "trainingCards/deleteTrainingCard",
  async (id, { rejectWithValue }) => {
    try {
      await apiClient.delete(`${ENDPOINT}${id}/`);
      return id;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || "Failed to delete training card");
    }
  }
);

// Slice

const trainingCardsSlice = createSlice({
  name: "trainingCards",
  initialState: {
    trainingCards: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Fetch
      .addCase(fetchTrainingCards.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchTrainingCards.fulfilled, (state, action) => {
        state.loading = false;
        state.trainingCards = action.payload;
      })
      .addCase(fetchTrainingCards.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Insert
      .addCase(insertTrainingCard.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(insertTrainingCard.fulfilled, (state, action) => {
        state.loading = false;
        state.trainingCards.push(action.payload);
      })
      .addCase(insertTrainingCard.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Update
      .addCase(updateTrainingCard.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateTrainingCard.fulfilled, (state, action) => {
        state.loading = false;
        const index = state.trainingCards.findIndex((card) => card.id === action.payload.id);
        if (index !== -1) {
          state.trainingCards[index] = action.payload;
        }
      })
      .addCase(updateTrainingCard.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Delete
      .addCase(deleteTrainingCard.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteTrainingCard.fulfilled, (state, action) => {
        state.loading = false;
        state.trainingCards = state.trainingCards.filter((card) => card.id !== action.payload);
      })
      .addCase(deleteTrainingCard.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default trainingCardsSlice.reducer;
